import { render, staticRenderFns } from "./ServiceRadioFormPart.fr.vue?vue&type=template&id=b46afd9c"
import script from "./ServiceRadioFormPart.fr.vue?vue&type=script&lang=js"
export * from "./ServiceRadioFormPart.fr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports